import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios, getRRAxios, postRRAxios } from "./axiosActions";
import _ from "lodash";
import { fetchSimilarReviews } from "./reviews";
import { fetchLocations } from "./location";
import toast from "../../common/toastNotistack";
import { setOtherFilter } from "../../common/utils/setOtherFilter";

export const initialState = {
  loading: false,
  hasErrors: false,
  facts: [],
  updateFact: [],
  deleteFact: [],
  localState:{
    factDevelopment:{inputData:{}, outputData:{}},
    FactData: null
  }
};

const factsSlice = createSlice({
  name: "facts",
  initialState,
  reducers: {
    getFacts: (state) => {
      state.loading = true;
    },
    getFactsSuccess: (state, { payload }) => {
      state.facts = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getFactsFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getUpdateFact: (state) => {
      state.loading = true;
    },
    getUpdateFactSuccess: (state, { payload }) => {
      state.updateFact = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getUpdateFactFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getDeleteFact: (state) => {
      state.loading = true;
    },
    getDeleteFactSuccess: (state, { payload }) => {
      state.deleteFact = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getDeleteFactFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    setFactLocalState:(state, {payload})=>{
      const {key, data, type} = payload;
      const temp = {...state.localState};
      temp[key] = data;
      state.localState = temp;
      
      if(key==='factDevelopment'&&type==='factInputData'){
        if(_.size(_.values(data.inputData))>0){
         setOtherFilter('factInputData', data.inputData, false);
      }
    }
    }
  },
});

export const {
  getFacts,
  getFactsSuccess,
  getFactsFailure,
  getUpdateFact,
  getUpdateFactSuccess,
  getUpdateFactFailure,
  getDeleteFact,
  getDeleteFactSuccess,
  getDeleteFactFailure,
  setFactLocalState
} = factsSlice.actions;
export const factsSelector = (state) => state.facts;
export default factsSlice.reducer;

export const triggerInsertFact = (data, reviewId) => {
  return async (dispatch) => {
    dispatch(getFacts(data));
    try {
      const response = await postRRAxios("api/Facts/InsertFact", {
        params: data,
      });
      await dispatch(getFactsSuccess(response));
      dispatch(fetchSimilarReviews(reviewId));
    } catch (error) {
      dispatch(getFactsFailure());
    }
  };
};


export const triggerEditFact = (data, reviewId) => {
  return async (dispatch) => {
    dispatch(getUpdateFact(data));
    try {
      const response = await postRRAxios("api/Facts/UpdateFact", {
        params: data,
      });
      await dispatch(getUpdateFactSuccess(response));
      dispatch(fetchSimilarReviews(reviewId));
    } catch (error) {
      dispatch(getUpdateFactFailure());
    }
  };
};

export function triggerDeleteFact(factId, reviewId) {
  return async (dispatch) => {
    dispatch(getDeleteFact());
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios("api/OpenAi/DeleteFact?factId=" + factId, {
        params: params,
      });
      await dispatch(getDeleteFactSuccess(data));
      dispatch(fetchSimilarReviews(reviewId));
    } catch (error) {
      dispatch(getDeleteFactFailure());
    }
  };
}
export function insertFacts(facts,reviewId) {
  return async dispatch => {
     dispatch(getFacts());
     try {
        const params = { callTime: new Date() };
        const data = await postRRAxios('api/OpenAi/InsertFact', { params: facts });
           if(data?.statusCode===200){
             await dispatch(getFactsSuccess(data));
             if(reviewId){
              dispatch(fetchSimilarReviews(reviewId));
             }
             toast('Fact Added Successfully!', { variant: 'success' })
           }
       
     } catch (error) {
        dispatch(getFactsFailure());
     }
  };
}
export function updateFacts(facts,reviewId) {
  return async dispatch => {
     dispatch(getFacts());
     try {
        const params = { callTime: new Date() };
        const data = await postRRAxios('api/OpenAi/UpdateFact', { params: facts });
           if(data?.statusCode===200){
             await dispatch(getFactsSuccess(data));
             if(reviewId){
              dispatch(fetchSimilarReviews(reviewId));
             }
             toast('Fact Edited Successfully!', { variant: 'success' })
           }
       
     } catch (error) {
        dispatch(getFactsFailure());
     }
  };
}
export function deleteFacts(factId,reviewId) {
  return async dispatch => {
     dispatch(getFacts());
     try {
        const params = { callTime: new Date() };
        const data = await getRRAxios('api/OpenAi/DeleteFact?factId='+factId, { params: params });
           if(data?.statusCode===200){
             await dispatch(getFactsSuccess(data));
             if(reviewId){
              dispatch(fetchSimilarReviews(reviewId));
             }
             toast('Fact Deleted Successfully!', { variant: 'success' })
           }
       
     } catch (error) {
        dispatch(getFactsFailure());
     }
  };
}
